export const switchFavicon = (stage) => {
    if (stage === 'production' || !stage) {
        return;
    }
    let iconFile;
    switch (stage) {
        case 'development':
            iconFile = 'favicon_development.png';
            break;
        case 'qa':
            iconFile = 'favicon_qa.png';
            break;
        case 'alpha':
            iconFile = 'favicon_alpha.png';
            break;
        case 'sandbox':
            iconFile = 'favicon_sandbox.png';
            break;
    }
    if (iconFile) {
        const favicon = document.querySelectorAll("link[rel~='icon']");
        if (favicon) {
            for (const i in favicon) {
                if (Object.prototype.hasOwnProperty.call(favicon, i)) {
                    favicon[i].href = `/favicon/stage/${iconFile}`;
                }
            }
        }
    }
};
//# sourceMappingURL=switchFavicon.js.map